var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandcraft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6409",
    "data-name": "Rectangle 6409",
    width: 53,
    height: 53,
    transform: "translate(380 28)",
    fill: "#FF6B5B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_16290",
    "data-name": "Groupe de masques 16290",
    transform: "translate(-380 -28)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cuir-faitmain",
    transform: "translate(377.35 24.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11848",
    "data-name": "Trac\\xE9 11848",
    d: "M30.21,9.222a.5.5,0,0,1-.53-.53v-3.5a.5.5,0,0,0-.53-.53H15.794a.5.5,0,0,0-.53.53V8.586a.53.53,0,1,1-1.06,0V5.194a1.674,1.674,0,0,1,1.7-1.7H29.15a1.654,1.654,0,0,1,1.59,1.7V8.586a.594.594,0,0,1-.53.636Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11849",
    "data-name": "Trac\\xE9 11849",
    d: "M22.472,30.634a.389.389,0,0,1-.318-.106l-3.5-2.65a.8.8,0,0,1-.212-.424V21.73a.5.5,0,0,1,.53-.53h7a.5.5,0,0,1,.53.53v5.724a.551.551,0,0,1-.212.424l-3.5,2.65a.389.389,0,0,1-.318.106Zm-2.968-3.5,2.968,2.226,2.968-2.226V22.26H19.5v4.876Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11850",
    "data-name": "Trac\\xE9 11850",
    d: "M18.656,26.712,2.968,20.14a.583.583,0,0,1-.318-.53V12.932a1.9,1.9,0,0,1,1.908-1.908H40.386a1.9,1.9,0,0,1,1.908,1.908V19.61a.583.583,0,0,1-.318.53L26.288,26.712l-.424-1.06,15.37-6.466v-6.36a.819.819,0,0,0-.742-.848H4.558a.756.756,0,0,0-.742.848v6.36l15.37,6.466Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11851",
    "data-name": "Trac\\xE9 11851",
    d: "M22.472,26.5a.5.5,0,0,1-.53-.53V24.486a.53.53,0,0,1,1.06,0V25.97A.568.568,0,0,1,22.472,26.5Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11852",
    "data-name": "Trac\\xE9 11852",
    d: "M16.536,12.084h-3.71a.5.5,0,0,1-.53-.53V8.586a.5.5,0,0,1,.53-.53h3.71a.5.5,0,0,1,.53.53v2.968C17.172,11.872,16.854,12.084,16.536,12.084Zm-3.18-1.166H15.9v-1.7H13.356Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11853",
    "data-name": "Trac\\xE9 11853",
    d: "M32.012,12.084H28.3a.5.5,0,0,1-.53-.53V8.586a.5.5,0,0,1,.53-.53h3.71a.5.5,0,0,1,.53.53v2.968c.106.318-.212.53-.53.53Zm-3.074-1.166h2.544v-1.8H28.938Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11854",
    "data-name": "Trac\\xE9 11854",
    d: "M53.742,55.65H25.864a1.9,1.9,0,0,1-1.908-1.908V47.594a.53.53,0,1,1,1.06,0v6.148a.836.836,0,0,0,.848.848H53.742a.836.836,0,0,0,.848-.848V34.768a.836.836,0,0,0-.848-.848H43.672a.53.53,0,1,1,0-1.06h10.07a1.9,1.9,0,0,1,1.908,1.908V53.742a1.9,1.9,0,0,1-1.908,1.908Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11855",
    "data-name": "Trac\\xE9 11855",
    d: "M24.486,41.552H5.936a1.9,1.9,0,0,1-1.908-1.908V23.32a.5.5,0,0,1,.53-.53.5.5,0,0,1,.53.53V39.644a.819.819,0,0,0,.742.848H23.956V34.874a1.9,1.9,0,0,1,1.908-1.908H39.75V20.352a.53.53,0,1,1,1.06,0V33.6a.5.5,0,0,1-.53.53H25.864a.836.836,0,0,0-.848.848v6.254c.106,0-.212.318-.53.318Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11856",
    "data-name": "Trac\\xE9 11856",
    d: "M32.648,33.92a.5.5,0,0,1-.53-.53V30.952a.53.53,0,1,1,1.06,0V33.39A.5.5,0,0,1,32.648,33.92Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11857",
    "data-name": "Trac\\xE9 11857",
    d: "M32.648,26.924a.5.5,0,0,1-.53-.53V23.956a.53.53,0,0,1,1.06,0v2.438A.5.5,0,0,1,32.648,26.924Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11858",
    "data-name": "Trac\\xE9 11858",
    d: "M12.19,40.916a.5.5,0,0,1-.53-.53V37.948a.53.53,0,0,1,1.06,0v2.438C12.826,40.7,12.508,40.916,12.19,40.916Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11859",
    "data-name": "Trac\\xE9 11859",
    d: "M12.19,33.92a.5.5,0,0,1-.53-.53V30.952a.53.53,0,1,1,1.06,0V33.39C12.826,33.708,12.508,33.92,12.19,33.92Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11860",
    "data-name": "Trac\\xE9 11860",
    d: "M12.19,26.924a.5.5,0,0,1-.53-.53V23.956a.53.53,0,0,1,1.06,0v2.438C12.826,26.712,12.508,26.924,12.19,26.924Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11861",
    "data-name": "Trac\\xE9 11861",
    d: "M30.634,37.524H28.2a.53.53,0,1,1,0-1.06h2.438a.5.5,0,0,1,.53.53A.568.568,0,0,1,30.634,37.524Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11862",
    "data-name": "Trac\\xE9 11862",
    d: "M37.524,37.524H35.086a.53.53,0,1,1,0-1.06h2.438a.5.5,0,0,1,.53.53C38.16,37.206,37.842,37.524,37.524,37.524Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11863",
    "data-name": "Trac\\xE9 11863",
    d: "M44.52,37.524H42.082a.53.53,0,1,1,0-1.06H44.52a.5.5,0,0,1,.53.53A.568.568,0,0,1,44.52,37.524Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11864",
    "data-name": "Trac\\xE9 11864",
    d: "M51.41,37.524H48.972a.53.53,0,0,1,0-1.06H51.41a.5.5,0,0,1,.53.53A.568.568,0,0,1,51.41,37.524Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11865",
    "data-name": "Trac\\xE9 11865",
    d: "M30.634,52.258H28.2a.53.53,0,1,1,0-1.06h2.438a.53.53,0,1,1,0,1.06Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11866",
    "data-name": "Trac\\xE9 11866",
    d: "M37.524,52.258H35.086a.53.53,0,1,1,0-1.06h2.438a.53.53,0,1,1,0,1.06Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11867",
    "data-name": "Trac\\xE9 11867",
    d: "M44.52,52.258H42.082a.53.53,0,1,1,0-1.06H44.52a.53.53,0,0,1,0,1.06Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11868",
    "data-name": "Trac\\xE9 11868",
    d: "M51.41,52.258H48.972a.53.53,0,0,1,0-1.06H51.41a.53.53,0,0,1,0,1.06Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11869",
    "data-name": "Trac\\xE9 11869",
    d: "M52.894,48.76H49.5a4.452,4.452,0,0,1,0-8.9h3.392a.53.53,0,0,1,0,1.06H49.5a3.392,3.392,0,0,0,0,6.784h3.392a.5.5,0,0,1,.53.53.568.568,0,0,1-.53.53Z",
    fill: "#FF6B5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11870",
    "data-name": "Trac\\xE9 11870",
    d: "M49.078,46.11a1.8,1.8,0,1,1,1.8-1.8A1.787,1.787,0,0,1,49.078,46.11Zm0-2.544a.742.742,0,1,0,.742.742A.725.725,0,0,0,49.078,43.566Z",
    fill: "#FF6B5B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandcraft);
export default __webpack_public_path__ + "static/media/handcraft.952e824ccd6fda8ca6e079c3b2edb0f7.svg";
export { ForwardRef as ReactComponent };